import React from 'react'
import MenuButton from './MenuButton'
import { useTheme } from '../ThemeContext'
import logo from '../Assets/Pictures/turtle.png'

export default function Header( { user, openMenu } ) {

  const darkTheme = useTheme()

  const styles = {
    backgroundColor : darkTheme ? 'rgb(100, 115, 130)' : 'rgb(235, 235, 235)',
    color: darkTheme ? '#eee' : '#111',
  }

  return (
    <header 
      style={styles}
      className='w-full h-auto flex items-center'
    >
      {
        user 
        ? 
          <div className='flex pl-2'>
            <img src={logo} alt="logo" className='turtle-one h-16 -rotate-12 mr-1 mt-1'/>
            <h1 className='font-pen text-6xl flex items-center'> Turtle </h1>
          </div>
        : 
          null
      }
      <MenuButton 
        openMenu={openMenu} 
      />
    </header>
  )
}
